import { Injectable } from '@angular/core';
import { StoreSummary } from '../../classes/models/store/StoreSummary';

/**
 * This service handles sorting the stores.
 */
@Injectable({
  providedIn: 'root'
})
export class StoreSortService {

  /**
   * Sorts stores by name alphabetically.
   * @param stores a list of stores to be sorted.
   */
  sortByName(stores: StoreSummary[]): StoreSummary[] {
    return stores.sort((a, b) => a.name.localeCompare(b.name));
  }
}
